import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-promotional-popup',
  templateUrl: './promotional-popup.component.html',
  styleUrls: ['./promotional-popup.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PromotionalPopupComponent {
  promotionCode = '9000000709';
  copied = false;

  constructor(public dialogRef: MatDialogRef<PromotionalPopupComponent>) {}

  closeDialog() {
    this.dialogRef.close();
  }

  availOffer() {
    window.open('https://www.seepex.com/de/aftermarket/?utm_source=Shop&utm_medium=Pop%20Up&utm_campaign=promotion', '_blank');
  }

  copyToClipboard() {
    navigator.clipboard
      .writeText(this.promotionCode)
      .then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  }
}
